import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';

function JntuhGoldMedalFelicitation20260208() {

    const images = [
        "jntuh-gold-medal-2026.jpeg",
    ];

    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="col-lg-12 ps-lg-4">
                                <div className="how-to-apply">
                                    <h2 className='pb-2'>
                                        JNTUH Felicitation of the Gold Medal Recipient
                                    </h2>

                                    <p>
                                        <strong>P. Hemasri</strong>, IT final year student, was felicitated on 
                                        <strong> 8th February 2026</strong> at the <strong>XIV JNTUH Convocation Ceremony</strong> 
                                        by the State Governor <strong>Sri Jushnu Dev Varma</strong>.
                                    </p>

                                    <p>
                                        She received the <strong>Gold Medal for the Best Outgoing Student of 
                                        Information Technology (IT)</strong> across all JNTUH-affiliated colleges.
                                    </p>

                                    <p>
                                        She was also honored with the prestigious <strong>Sangam Laxmi Bai Gold Medal</strong> 
                                        for the best outgoing girl student, recognizing her exemplary all-around 
                                        performance and commitment to excellence.
                                    </p>

                                    <p>
                                        This prestigious achievement reflects her dedication, hard work, and 
                                        commitment, and is a proud moment for our institution. 
                                        Congratulations and best wishes for her continued success.
                                    </p>

                                    <div className="spotlight-group">
                                        <div className="row">
                                            {images.map((img, index) => (
                                                <div className="col-md-6 mb-3 mb-lg-4" key={index}>
                                                    <a
                                                        className="spotlight"
                                                        href={`https://admin.swec.ac.in/assetsswec/img/jntuh-gold-medal-2026/${img}`}
                                                    >
                                                        <img
                                                            src={`https://admin.swec.ac.in/assetsswec/img/jntuh-gold-medal-2026/${img}`}
                                                            alt={`Image ${index + 1}`}
                                                            className="img-responsive center-block rounded-1"
                                                        />
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <Footer />
        </div>
    )
}

export default JntuhGoldMedalFelicitation20260208;
